module.exports = __webpack_public_path__ + "static/media/dad.e0b35d9b.jpg";